import { PAGE_TYPES } from '../shared/utils/analytics/constants'

export const microPrefix = 'nol-portal-register'

export function getPageType(slug) {
	if (slug === '/registro/') return PAGE_TYPES.GENERIC

	return PAGE_TYPES.GENERIC
}
